<template>
  <v-row
    no-gutters
    center
    class="NotFound mt-12">
    <v-container
    >
      <v-row
        no-gutters
        align="center"
        class="justify-center align-content-center">
        <v-col
          cols="12"
          sm="6"
          xs="12"
          class="offset-sm-3 align-content-center"
        >
          <v-card
            flat
            class="NotFound--card">
            <!-- Img xs -->
            <v-img
              class="imgxs ml-7 mt-3"
              src="/assets/duck.png"
              width="120px"
              height="120px"/>
            <!-- 404 Text -->
            <v-card-text>
              <v-col
                cols="12"
                class="black--text font-weight-bold display-4">
                {{ $t('notFound.404') }}
              </v-col>
              <v-col
                class="headline py-0 mt-4 black--text font-weight-bold"
                cols="12">
                {{ $t('notFound.quack') }}

              </v-col>
            </v-card-text>
            <v-card-text
              class="body-1">
              <v-row no-gutters>

                <!-- Install -->
                <v-col
                  cols="12"
                  class="mt-4 pa-3">
                  <v-btn
                    :href="`${externalLinks.siteHome}`"
                    color="primary"
                    rounded
                    x-large
                    class="capitalize--text font-weight-bold icon-google pl-12"
                  >
                    <span class="ml-2">
                      {{ $t('booked.installGmelius') }}
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

    </v-container>
    <!-- Footer -->
    <v-footer
      fixed
      color="white"
      class="Footer">
      <v-container class="Footer">
        <v-row
          no-gutters>
          <v-col
            xs="12"
            cols="12"
            sm="6"
            class="align-content-center d-flex mt-2">
            <a
              :href="`${externalLinks.siteHome}`"
              target="_blank"
              class="grey--text text--darken-2 caption d-flex align-content-center mr-1">
              {{ $t('notFound.gmelius') }}</a>
            <a
              href="https://community.gmelius.com"
              target="_blank"
              class="grey--text text--darken-2 caption d-flex align-content-center mr-1"
            > {{ $t('notFound.help') }}</a>
            <a
              href="https://community.gmelius.com"
              target="_blank"
              class="grey--text text--darken-2 caption d-flex align-content-center"
            > {{ $t('notFound.community') }}</a>
          </v-col>
          <v-col
            xs="12"
            cols="12"
            sm="6"
            class="d-flex justify-sm-end justify-xs-center mt-2">
            <a
              href="https://play.google.com/store/apps/details?id=com.gmelius.app"
              target="_blank">
              <img
                src="https://gmelius.com/_nuxt/img/59ea50a.png"
                height="36"
                class="d-block mr-4"
                alt="Gmelius for Android" >
            </a>
            <a
              href="https://itunes.apple.com/us/app/gmelius/id1452777323"
              target="_blank">
              <img
                height="36"
                src="https://gmelius.com/_nuxt/img/62dbbd6.png"
                class="d-block"
                alt="Gmelius for IOS" >
            </a>

        </v-col></v-row>
      </v-container >
    </v-footer>
  </v-row>
</template>

<script>
import { localeMixin } from '../mixins'
import { externalLinks } from '../config'
export default {
  mixins: [localeMixin],
  data () {
    return {
      externalLinks,
      loaded: false
    }
  }
}
</script>
<style lang="scss">
.NotFound {
  background-image: url("/assets/ducklg.png");
  background-repeat: no-repeat;
  background-position: bottom left;
  background-size: contain;
  @media screen and (max-width: 600px) {
    background-image: none;
  }
  @media screen and (min-width: 1441px) {
    background-image:url("/assets/duck.png");
  }
  &--card {
    background-color: transparent !important;
    .imgxs {
      display: none !important;
      @media screen and (max-width: 600px) {
        display: block !important;
      }
    }
  }
}
</style>
